export default __webpack_public_path__ + "static/media/icon-edit.1a4b58e2.svg";